import { useNavigate } from "react-router-dom";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import { accountService } from "../../_services/accounts.service";
import { UserProfileCurrentForm } from "./userProfile-currentForm";
import { UserProfileInformationNoteList } from "./userProfile-informationNoteList";
import { UserProfileLicenseList } from "./userProfile-licenseList";
import { UserLicenseTypeEnum } from "../../_common/enum/forms/userLicenseType.enum";
import { UserProfileMediaNoteList } from "./userProfile-mediaNoteList";


export function UserProfileGenericLicenseIndex(params: { formTemplateType: FormTemplateTypeEnum, userLicenseType: UserLicenseTypeEnum }) {
    const navigate = useNavigate();
    return (
        <>
            <UserProfileCurrentForm currentForm={params.formTemplateType} />
            <UserProfileLicenseList userLicenseType={params.userLicenseType} />

            {accountService.isAdmin &&
                <div style={{ marginTop: "30px" }}>
                    <UserProfileMediaNoteList />
                </div>
            }
        </>
    );
}